import type { SearchHit } from "./algolia";
import SearchResultItem from "./searchResult";

const ResultsList = ({ searchResults }: { searchResults: SearchHit[] }) => {
  return (
    <div>
      <ul>
        {searchResults?.map((result) => (
          <SearchResultItem key={result.objectID} searchResult={result} />
        ))}
      </ul>
    </div>
  );
};

export default ResultsList;
